<div class="row row-sm">
    <div class="col-lg-12">
        <div class="card-body">
            <div class="row">
                <div class="col-md-12" *ngIf="submitButton">
                    <div class=" bc d-flex align-items-center pl-3">
                        <!-- <img alt="Logo" src="../../assets/img/StateMaster.png" class="mh-45px pb-2"> -->
                        <div class="ml-2">
                            <h4 class="main-content-label mb-1"><b>
                                    Student Attendance
                                </b></h4>
                            <p class="text-muted card-sub-title mb-0">
                               Add New Student Attendance Record
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-12" *ngIf="editButton">
                    <div class=" bc d-flex align-items-center pl-3">
                        <!-- <img alt="Logo" src="../../assets/img/StateMaster.png" class="mh-45px pb-2"> -->
                        <div class="ml-2">
                            <h4 class="main-content-label mb-1"><b>
                                    Student Attendance
                                </b></h4>
                            <p class="text-muted card-sub-title mb-0">
                                Update Student Attendance Record
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-12" *ngIf="deleteButton">
                    <div class=" bc d-flex align-items-center pl-3">
                        <!-- <img alt="Logo" src="../../assets/img/StateMaster.png" class="mh-45px pb-2"> -->
                        <div class="ml-2">
                            <h4 class="main-content-label mb-1"><b>
                                    Student Attendance
                                </b></h4>
                            <p class="text-muted card-sub-title mb-0">
                                Delete Student Attendance Record
                            </p>
                        </div>
                    </div>
                </div>
                <hr class="mt-3">

                <div class="row row-sm add-form ">
                    <form autocomplete="off" class="p-0" novalidate [formGroup]="AttendanceForm ">
                        <div class="col-lg-12 col-md-12">
                            <div class="row clearfix ">
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label>Session</mat-label>
                                            <mat-select #select232 placeholder="Session" class="colorblack"
                                                formControlName="Session">
                                                <mat-select-filter *ngIf="select232.focused"
                                                    [placeholder]="'Filter'" [displayMember]="'SnName'"
                                                    [array]="sessionList"
                                                    (filteredReturn)="SessionFilterList =$event"></mat-select-filter>
                                                <mat-option *ngFor="let item of SessionFilterList"
                                                    [value]="item.SnNo" (click)="session(item.SnNo)">
                                                    {{item.SnName}}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error class="margin_tp"
                                                *ngIf="AttendanceForm.controls['Session'].touched && AttendanceForm.controls['Session'].errors?.required">
                                                This Field Is Mandatory
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label> Name Of Examination</mat-label>
                                            <input onkeydown="return (event.keyCode!=13);"
                                                        style="color:black;" type="text" placeholder="Name Of Examination"
                                                        formControlName="ExamName" matInput>
                                            <!-- <mat-select #select23 placeholder="Name Of Examination"
                                                class="colorblack" formControlName="ExamName">
                                                <mat-select-filter *ngIf="select23.focused"
                                                    [placeholder]="'Filter'" [displayMember]="'CgName'"
                                                    [array]="collegeList"
                                                    (filteredReturn)="filteredCollegeList =$event">
                                                </mat-select-filter>
                                                <mat-option *ngFor="let item of filteredCollegeList"
                                                    [value]="item.CgCode">
                                                </mat-option>
                                            </mat-select> -->
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group1">
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label>Faculty</mat-label>
                                            <mat-select required #select33 placeholder="Faculty"
                                                class="colorblack" formControlName="Faculty">
                                                <mat-select-filter *ngIf="select33.focused"
                                                    [placeholder]="'Filter'" [displayMember]="'FcDesc'"
                                                    [array]="fcCodeList"
                                                    (filteredReturn)="filteredListFcCode =$event">
                                                </mat-select-filter>
                                                <mat-option *ngFor="let item of filteredListFcCode"
                                                    [value]="item.FcCode">
                                                    {{item.FcCode}} - {{item.FcDesc}}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error class="margin_tp"
                                                *ngIf="AttendanceForm.controls['Faculty'].touched && AttendanceForm.controls['Faculty'].errors?.required">
                                                This Field Is Mandatory
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label> Course</mat-label>
                                            <mat-select #select22 placeholder="Course" class="colorblack"
                                                formControlName="Course">
                                                <mat-select-filter *ngIf="select22.focused"
                                                    [placeholder]="'Filter'" [displayMember]="'CoName'"
                                                    [array]="courseList"
                                                    (filteredReturn)="filteredCourseList =$event">
                                                </mat-select-filter>
                                                <mat-option *ngFor="let item of filteredCourseList"
                                                    [value]="item.CoCode"
                                                    (click)="fetchBranch(item.CoCode)">{{item.CoCode}}
                                                    - {{item.CoName}}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error class="margin_tp"
                                                *ngIf="AttendanceForm.controls['Course'].touched && AttendanceForm.controls['Course'].errors?.required">
                                                This Field Is Mandatory
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label> College</mat-label>
                                            <mat-select #select233 placeholder="College" class="colorblack"
                                                formControlName="College">
                                                <mat-select-filter *ngIf="select233.focused"
                                                    [placeholder]="'Filter'" [displayMember]="'CgName'"
                                                    [array]="collegeList"
                                                    (filteredReturn)="filteredCollegeList =$event">
                                                </mat-select-filter>
                                                <mat-option *ngFor="let item of filteredCollegeList"
                                                    [value]="item.CgCode"
                                                    (click)="ClgCd(item.CgCode)">{{item.CgCode}} -
                                                    {{item.CgName}}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error class="margin_tp"
                                                *ngIf="AttendanceForm.controls['College'].touched && AttendanceForm.controls['College'].errors?.required">
                                                This Field Is Mandatory
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label>
                                                Branch - Pattern
                                            </mat-label>
                                            <mat-select #select53 class="colorblack"
                                                formControlName="Branch">
                                                <mat-select-filter *ngIf="select53.focused"
                                                    [placeholder]="'Filter'" [displayMember]="'item.StrId'"
                                                    [array]="BranchList"
                                                    (filteredReturn)="filteredListBranch =$event">
                                                </mat-select-filter>
                                                <mat-option *ngFor="let item of filteredListBranch"
                                                    [value]="item.StrId">
                                                    {{item.StrName}}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error class="margin_tp"
                                                *ngIf="AttendanceForm.controls['Branch'].touched && AttendanceForm.controls['Branch'].errors?.required">
                                                This Field Is Mandatory
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label>Exam</mat-label>
                                            <mat-select #select52 class="colorblack" formControlName="Exam">
                                                <mat-select-filter *ngIf="select52.focused"
                                                    [placeholder]="'Filter'" [displayMember]="'EmName'"
                                                    [array]="examList"
                                                    (filteredReturn)="filteredListExam =$event">
                                                </mat-select-filter>
                                                <mat-option *ngFor="let item of filteredListExam"
                                                    [value]="item.EmId" (click)="getSubjects(item.EmId)">
                                                    {{item.EmCode}} - {{item.EmName}}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error class="margin_tp"
                                                *ngIf="AttendanceForm.controls['Exam'].touched && AttendanceForm.controls['Exam'].errors?.required">
                                                This Field is Mandatory
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label>Subjects</mat-label>
                                            <mat-select #select52 class="colorblack"
                                                formControlName="Subject">
                                                <mat-select-filter *ngIf="select52.focused"
                                                    [placeholder]="'Filter'" [displayMember]="'EsName'"
                                                    [array]="examSubList"
                                                    (filteredReturn)="filteredListExamSub =$event">
                                                </mat-select-filter>
                                                <mat-option *ngFor="let item of filteredListExamSub"
                                                    [value]="item.EsId" (click)="ShowTable()">
                                                    {{item.EsCode}} - {{item.EsName}}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error class="margin_tp"
                                                *ngIf="AttendanceForm.controls['Subject'].touched && AttendanceForm.controls['Subject'].errors?.required">
                                                This Field is Mandatory
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="table-responsive table-container mt-3" *ngIf="atdTbl">
                                    <table  class="table table-bordered text-nowrap">
                                        <thead>
                                            <tr>
                                                <th class="f600"> Sr No. </th>
                                                <th class="f600"> PR No. </th>
                                                <th class="f600"> Student Name </th>
                                                <th class="f600"> Subject Attendance(Min 70.00%)</th>
                                                
                                            </tr>
                                        </thead>
                                        <tbody id="table_data" formArrayName="AtdArray">
                                            <tr *ngFor="let atd of getAtdArrayControls(); let i = index;"
                                                [formGroupName]="i">
                                                <td>
                                                    <input class="form-control input-sm"
                                                        formControlName="SrNo" readonly>
                                                </td>
                                                <td>
                                                    <input class="form-control input-sm"
                                                        formControlName="PrNo" readonly>
                                                </td>
                                                <td>
                                                    <input class="form-control input-sm"
                                                        formControlName="StuName" readonly>
                                                </td>
                                                <td>
                                                    <mat-form-field appearance="outline"
                                                        class="example-full-width">
                                                        <mat-label>Attendance Percent</mat-label>
                                                        <input required matInput
                                                            onkeydown="return (event.keyCode!=13);"
                                                            class="color" formControlName="AtndPrcnt">
                                                    </mat-form-field>
                                                </td>
                                                
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="row mb-2">
                                    <div class="col-sm-3 pri-0 offset-sm-6">
                                        <button type="button" [mat-dialog-close]="true"
                                            class="btn btn-primary btn-icon-text floatright mt-1">
                                            <span style="display: contents; align-items: center; margin-left:1rem;">
                                                <img width="23%" src="../../assets/img/turn-left.gif"
                                                    style="margin-right: 5px;">
                                                Back
                                            </span>
                                        </button>

                                    </div>
                                    <div class="col-sm-3 pri-0" *ngIf="submitButton">
                                        <button type="button"
                                                        class="btn btn-primary btn-icon-text floatright mt-1"
                                                        (click)="Submit('new')">
                                                        <span style="display: contents; align-items: center;">
                                                            <img width="15vh" class="p-0"
                                                                src="../../assets/img/save.gif">
                                                            Save
                                                        </span>
                                                    </button>
                                    </div>
                                    <div class="col-sm-3 pri-0" *ngIf="editButton">
                                        <button type="button" class="btn btn-primary btn-icon-text floatright mt-1"
                                            (click)="update()">
                                            <span style="display: contents; align-items: center;">
                                                <img width="29%" src="../../assets/img/edit1.gif"
                                                    style="margin-right: 5px;">
                                                Update
                                            </span>
                                        </button>

                                    </div>
                                    <div class="col-sm-3 pri-0" *ngIf="deleteButton">
                                        <button type="button" class="btn btn-primary btn-icon-text floatright mt-1"
                                          (click)="DeletetheRecord()"  >
                                            <span style="display: contents; align-items: center;">
                                                <img width="30%" src="../../assets/img/trash.gif"
                                                    style="margin-right: 5px;">
                                                Delete
                                            </span>
                                        </button>
                                    </div>

                                </div>

                            </div>


                        </div>
                    </form>
                </div>
            </div>
        </div>

    </div>
</div>